import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import key from '../images/key.png';
import gridvault_logo_icon from '../images/gridvault_logo_icon.jpg';

import { Link } from 'react-router-dom';

// import '../css/home.css';

export default function StartPage() {
  const theme = useTheme();
  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          marginBottom: '175%',
          // backgroundColor: 'red',
        }}
      >
        <Link to={'/privacy'}>
          <img src={gridvault_logo_icon}
            alt="gridvault icon"
            className='home-icon'
            style={{ width: '50px', borderRadius: '10px' }}
          />
        </Link>
      </Box>
    </React.Fragment>
  );
}